export const useLocalStorage = (globalKey?: string) => {
  const getItem = (key: string) => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem(globalKey || key);
  };

  const setItem = (key: string, value: any) => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(globalKey || key, value);
  };

  const removeItem = (key: string) => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(globalKey || key);
  };

  const clear = () => {
    if (typeof window === 'undefined') return;
    localStorage.clear();
  };

  return {
    getItem,
    setItem,
    removeItem,
    clear,
  };
};
